import { render, staticRenderFns } from "./FrequentQuestionComponent.vue?vue&type=template&id=0d2f6209&scoped=true&lang=html"
import script from "./FrequentQuestionComponent.vue?vue&type=script&lang=js"
export * from "./FrequentQuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./FrequentQuestionComponent.vue?vue&type=style&index=0&id=0d2f6209&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2f6209",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2f6209')) {
      api.createRecord('0d2f6209', component.options)
    } else {
      api.reload('0d2f6209', component.options)
    }
    module.hot.accept("./FrequentQuestionComponent.vue?vue&type=template&id=0d2f6209&scoped=true&lang=html", function () {
      api.rerender('0d2f6209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FrequentQuestionComponent.vue"
export default component.exports